/**
 * Password requirements:
 * 8 characters
 * At least one number
 * At least one symbol
 * At least one upper case letter
 */
import type { FormKitNode } from "@formkit/core";
import {
  passwordValidationRules,
  requiredLowercaseChars,
  requiredNumbers,
  requiredPasswordLength,
  requiredSpecialChars,
  requiredUppercaseChars,
} from "@shared/validation/password";

export const formkitPasswordValidationRules = {
  passwordHasLength: (node: FormKitNode) =>
    passwordValidationRules.hasLength.test(node.value as string),
  passwordHasNumber: (node: FormKitNode) =>
    passwordValidationRules.hasNumber.test(node.value as string),
  passwordHasSpecial: (node: FormKitNode) =>
    passwordValidationRules.hasSpecialCharacter.test(node.value as string),
  passwordHasUppercase: (node: FormKitNode) =>
    passwordValidationRules.hasUppercase.test(node.value as string),
  passwordHasLowercase: (node: FormKitNode) =>
    passwordValidationRules.hasLowercase.test(node.value as string),
};

export default {
  requiredPasswordLength,
  requiredNumbers,
  requiredSpecialChars,
  requiredUppercaseChars,
  requiredLowercaseChars,
};
